/* unplugin-vue-components disabled */import { render } from "./IntroGallery.vue?vue&type=template&id=b1b821c4&scoped=true"
import script from "./IntroGallery.vue?vue&type=script&lang=js"
export * from "./IntroGallery.vue?vue&type=script&lang=js"

import "./IntroGallery.vue?vue&type=style&index=0&id=b1b821c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b821c4"]])

export default __exports__